// extracted by mini-css-extract-plugin
export default {"questionMarkContainer":"QuestionMarkAnimation_questionMarkContainer__Uv9v2","questionMarkAnimation":"QuestionMarkAnimation_questionMarkAnimation__InZME"};